import React, { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useModal } from "../../hooks/ModalContext";

import LocalLookup from "./LocalLookup";
import ConditionalLookup from "./ConditionalLookup";
import ExternalLookup from "./ExternalLookup";

const ModalComponent = () => {
  const {
    isModalVisible,
    hideModal,
    screenNumber,
    modalProps = {},
    receiveData,
    sourceData,
    readOnly,
    navigateToScreen,
  } = useModal();

  const getComponent = (hide) => {
    const {
      params: { lookupType },
    } = modalProps;
    switch (lookupType) {
      case "external":
        return (
          <ExternalLookup
            {...modalProps}
            onSelect={receiveData}
            hideModal={hideModal}
            selectMode={true}
            readOnly={readOnly}
            sourceData={sourceData}
            onNavigate={navigateToScreen}
          />
        );
      case "conditional":
        return (
          <ConditionalLookup
            {...modalProps}
            screenNumber={screenNumber}
            sourceData={sourceData}
            hideModal={hideModal}
            receiveData={receiveData}
            readOnly={readOnly}
            onNavigate={navigateToScreen}
          />
        );
      case "local":
        return (
          <LocalLookup
            {...modalProps}
            hideModal={hideModal}
            receiveData={receiveData}
            screenNumber={screenNumber}
            readOnly={readOnly}
            sourceData={sourceData}
            onNavigate={navigateToScreen}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    function handleKeydown(event) {
      if (event.key === "F12" && isModalVisible) {
        event.preventDefault(); // Prevent the default browser action
        event.stopPropagation(); // Stop propagation to base screen
        hideModal(); // Close the dialog
      }
    }

    // Attach event listener only when the dialog is open
    //if (isModalVisible) {
    window.addEventListener("keydown", handleKeydown);
    // }

    // Clean up event listener when dialog is closed
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [isModalVisible, hideModal]);

  return (
    <Dialog
      modal
      visible={isModalVisible}
      style={{ width: "50vw" }}
      onHide={hideModal}
      content={({ hide }) => screenNumber && getComponent(hide)}
    />
  );
};

export default ModalComponent;
